// extracted by mini-css-extract-plugin
export var editButton = "_pg-0";